import React, { useEffect, useState } from 'react';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import './Skill.scss'
import Animated from '../AnimatedLetters/Animated';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCss3, faHtml5, faJsSquare, faNodeJs, faReact, faPython } from '@fortawesome/free-brands-svg-icons';
import { faDatabase } from '@fortawesome/free-solid-svg-icons';

const Skill = () => {
    const [letterClass, setLetterClass] = useState('text-animate')

    useEffect(() => {
        setTimeout(() => {
            setLetterClass('text-animate-hover')
        }, 3000)
    }, [])

    return (
        <Container className='skill-s'>
            <Row>
                <Col md={8}>

                    <div className="text-zone">
                        <h1>
                            <Animated
                                letterClass={letterClass}
                                strArray={['M', 'y', ' ', 'S', 'k', 'i', 'l', 'l', 's']}
                                idx={15}
                            />
                        </h1>
                        <div className='text-white mt-3 mb-5'>
                            <p >
                                Full stack developer proficient in both frontend and backend technologies including
                                <p><span className="text-warning">MERN Stack (MongoDB, Express, React, Node.js), Django, Python, NoSQL/SQL databases, JWT, Nginx, React-query</span> etc.</p>

                                I have a good sense of aesthetics and experience in responsive, mobile-first web design. I put special
                                effort into optimizing my code and providing the best user
                                experience across the full stack. I guarantee a commitment during work on
                                your project and provide support after completion.
                            </p>
                            <p>
                                Visit my <a className='d-inline text-warning mx-1 fs-6' href="https://www.linkedin.com/in/arefin-khan-441259241/" target="_blank" rel='noreferrer'>Linkedin</a>
                                profile for more details. Also you can checkout my cv on this <a className='d-inline text-warning mx-1 fs-6' href="https://drive.google.com/file/d/1Q2rPsxXGzdawfoV3Fb4x_SYp0xhlTWrn/view" target="_blank" rel='noreferrer'>Link</a>.
                            </p>
                        </div>
                    </div>

                </Col>
                <Col md={4}>

                    <div className="stage-cube-cont">
                        <div className="cubespinner">
                            <div className="face1">
                                <FontAwesomeIcon icon={faNodeJs} color="#DD0031" />
                            </div>
                            <div className="face2">
                                <FontAwesomeIcon icon={faPython} color="#306998" />
                            </div>
                            <div className="face3">
                                <FontAwesomeIcon icon={faDatabase} color="#336791" />
                            </div>
                            <div className="face4">
                                <FontAwesomeIcon icon={faReact} color="#5ED4F4" />
                            </div>
                            <div className="face5">
                                <FontAwesomeIcon icon={faJsSquare} color="#EFD81D" />
                            </div>
                            <div className="face6">
                                <FontAwesomeIcon icon={faHtml5} color="#EC4D28" />
                            </div>
                        </div>
                    </div>

                </Col>
            </Row>
        </Container >
    );
};

export default Skill;